import * as types from '../event_types'
import Vue from 'vue';
import * as restlet from '../actions/rest'
import * as passwordless from '../actions/passwordless'
import * as login from '../actions/login'
import * as util from '../../util'
import Cookies from 'js-cookie'
// STATE

const state = {
  connection:"",
  no_account: false,
  link_sent: false
}

// GETTERS

const getters = {
  connection: state => state.connection,
  no_account: state => state.no_account,
  link_sent: state => state.link_sent
}

// ACTIONS

const actions = {
  determineLogin ({
    dispatch,
    commit
  }, login) {
    commit(types.SET_NO_ACCOUNT, false) 
    restlet.getConnection(login.email).then(function(response){
      if(response.data.data){
        commit(types.SET_CONNECTION, response.data.data)
        if(response.data.data.login == 'passwordless'){
          Cookies.set('state', login.state)
          dispatch('sendMagicLink', login.email)
        }else{
          dispatch('sendToLogin', login.state)
        }
      }else {
        commit(types.SET_NO_ACCOUNT, true) 
      }
    })
  },
  verifyAuthentication ({
    dispatch
  }, verifyData) {
    passwordless.verify(verifyData.hash).then(function(token){
      restlet.authenticate(token, verifyData.state).then(function(response){
        if(response.status == 204){
            dispatch('redirect', verifyData.state)
        }
      })
    })
  },
  startMobile({ dispatch }, redirectUrl) {
    dispatch('redirect', redirectUrl)
  },
  sendMagicLink({commit}, email) {
    passwordless.start(email).then(function(){
      commit(types.SET_LINK_SENT, true)
    })
  },
  sendToLogin(_s, view) {
    if(util.isMobileSafari() && view.startsWith("circle-welcome://")){
      login.start(window.location.protocol + "//" + window.location.hostname + "/mobile?page=" + view)
    }else{
      login.start(view)
    }
  },
  redirect(_s, view) {
    if(util.isMobileSafari() && view.startsWith("circle-welcome://")){
      let token = Cookies.get('token')
      window.location = view + '?id_token=' + token 
    }else{
      window.location = view
    }
  },
  logOut(_s) {
    Cookies.remove('token')
    Cookies.remove('user')
    login.logout()
  },
  triggerRegistration(_s, register) {
    login.signup(register.state)
  }
}

// MUTATIONS

/* eslint no-param-reassign:
["error", { "props": false}] */

const mutations = {
  setConnection(s, resp) {
    Vue.set(s, 'connection', resp.login)
  },
  setNoAccount(s, resp) {
    Vue.set(s, 'no_account', resp)
  },
  setLinkSent(s, sent) {
    Vue.set(s, 'link_sent', sent)
  }
}

// EXPORT

export default {
  state,
  getters,
  actions,
  mutations
}
